const CONSTANTS = {
  BREAKPOINTS: {
    mobile: 420,
    tablet: 768,
    desktop: 1024,
    wide: 1440,
    hd: 2560
  },
  DATE: {
    DATE_FORMAT: "YYYY-MM-DD"
  }
};

export { CONSTANTS as default };
//# sourceMappingURL=bundle.esm.js.map
